import React, { useState } from 'react';
import { API_BASE_URL } from '../api/config';


function ReviewModal({ groupId, username, isOwner, owner, participants, onClose, onSubmit }) {
  const [reviews, setReviews] = useState({});
  const [error, setError] = useState('');

  // 평가 대상자 목록 가져오기
  const getReviewees = () => {
    if (isOwner) {
      // 주최자는 나머지 참여자들 모두 평가 (자신 제외)
      return participants.filter(p => p !== username);
    } else {
      // 참여자는 주최자만 평가
      return [owner];
    }
  };

  const reviewees = getReviewees();

  const handleRatingChange = (reviewee, rating) => {
    setReviews(prev => ({
      ...prev,
      [reviewee]: { ...prev[reviewee], rating }
    }));
  };

  const handleCommentChange = (reviewee, comment) => {
    setReviews(prev => ({
      ...prev,
      [reviewee]: { ...prev[reviewee], comment }
    }));
  };

  const handleSubmit = async () => {
    setError('');

    // 모든 평가가 완료되었는지 확인
    for (const reviewee of reviewees) {
      if (!reviews[reviewee]?.rating) {
        setError(`${reviewee}님의 별점을 선택해주세요`);
        return;
      }
    }

    try {
      // 각 평가를 서버에 전송
      const promises = reviewees.map(reviewee => 
        fetch(`${API_BASE_URL}/api/reviews/group/${groupId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            reviewer: username,
            reviewee: reviewee,
            rating: reviews[reviewee].rating,
            comment: reviews[reviewee].comment || ''
          })
        })
      );

      await Promise.all(promises);
      alert('평가가 완료되었습니다! 🎉');
      if (onSubmit) onSubmit();
      onClose();
    } catch (e) {
      setError('평가 제출 실패');
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000,
      overflowY: 'auto'
    }}>
      <div style={{
        backgroundColor: 'white', padding: 24, borderRadius: 8,
        maxWidth: 500, width: '90%', maxHeight: '80vh', overflowY: 'auto'
      }}>
        <h3>{isOwner ? '참여자 평가' : '주최자 평가'}</h3>
        <p style={{ color: '#666', marginBottom: 16 }}>
          {isOwner 
            ? '공구에 참여한 멤버들을 평가해주세요.' 
            : '주최자를 평가해주세요.'}
        </p>

        {reviewees.map(reviewee => (
          <div key={reviewee} style={{
            border: '1px solid #e5e7eb',
            padding: 16,
            borderRadius: 8,
            marginBottom: 16
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{reviewee}</div>
            
            <div style={{ marginBottom: 8 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: '14px' }}>
                별점 <span style={{ color: 'red' }}>*</span>
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                {[1, 2, 3, 4, 5].map(star => (
                  <button
                    key={star}
                    onClick={() => handleRatingChange(reviewee, star)}
                    style={{
                      fontSize: '24px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: 0
                    }}
                  >
                    {(reviews[reviewee]?.rating || 0) >= star ? '⭐' : '☆'}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: 4, fontSize: '14px' }}>
                한줄 평가 (선택)
              </label>
              <textarea
                value={reviews[reviewee]?.comment || ''}
                onChange={e => handleCommentChange(reviewee, e.target.value)}
                placeholder="좋았던 점이나 개선할 점을 남겨주세요"
                style={{
                  width: '100%',
                  minHeight: 60,
                  padding: 8,
                  borderRadius: 4,
                  border: '1px solid #d1d5db'
                }}
              />
            </div>
          </div>
        ))}

        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn" onClick={handleSubmit}>평가 제출</button>
          <button className="btn secondary" onClick={onClose}>나중에</button>
        </div>
      </div>
    </div>
  );
}

export default ReviewModal;
